/**
 * KpiCard (M10, RF-M10-001) — card de indicador do painel de totais.
 *
 * Renderiza rótulo + valor. Quando a seção está `indisponivel` (degradação por
 * seção, AC4), mostra "—" e um aviso discreto, sem derrubar os demais cards.
 */

export interface KpiCardProps {
  readonly rotulo: string;
  readonly valor: number;
  readonly indisponivel?: boolean;
  /** Linha de detalhe sob o valor (ADR-038: "N com imagem · M planilha (sem imagem)"). */
  readonly detalhe?: string;
}

/** Formata inteiros com separador de milhar (pt-BR). */
function formatarNumero(n: number): string {
  return new Intl.NumberFormat('pt-BR').format(n);
}

export function KpiCard({ rotulo, valor, indisponivel = false, detalhe }: KpiCardProps): JSX.Element {
  return (
    <div className="kpi-card" role="group" aria-label={rotulo}>
      <span className="kpi-rotulo">{rotulo}</span>
      <span className="kpi-valor">{indisponivel ? '—' : formatarNumero(valor)}</span>
      {!indisponivel && detalhe && <span className="kpi-detalhe muted">{detalhe}</span>}
      {indisponivel && <span className="kpi-indisponivel muted">indisponível</span>}
    </div>
  );
}
